import * as React from 'react';

import { Button } from '../Button';
import { Text } from '../Text';
import { Icon } from '../Icon';
import { TextAndIcon } from '../TextAndIcon';
import { MountPopup } from '../PopupViewer';
import { Container } from '../Container';
import { SIZE_4, SIZE_20, SIZE_24, SIZE_28, SIZE_360, SIZE_WIDE } from '../../constants/sizes';
import { ClickOutside } from '../outside';
import { Link } from '../Link';
import { trackProblemIconHover, trackProblemMoreButtonClick } from '../../actions/analytics';

interface IPopupOwnProps {
  url: string;
  GKId: number;
}

interface IPopupState {
  isOpen: boolean;
}

export class ProblemNewbuildingPopup extends React.PureComponent<IPopupOwnProps, IPopupState> {
  public state: Readonly<IPopupState> = {
    isOpen: false,
  };

  private onIconHover = () => {
    const { GKId } = this.props;
    trackProblemIconHover(GKId);
  }

  private onMoreButtonClick = () => {
    const { GKId } = this.props;
    trackProblemMoreButtonClick(GKId);
  }

  public render() {
    const {
      isOpen,
    } = this.state;
    let { url = '' } = this.props;

    if (url) {
      url = `${url}#problem`;
    }

    return (
      <span
        onMouseEnter={this.handleToggle(true)}
        onMouseLeave={this.handleToggle(false)}
        onClick={this.handleToggle(true)}
      >
        <MountPopup
          placement="bottom"
          padding={-20}
          component={
            isOpen &&
            <ClickOutside
              onOutside={this.handleToggle(false)}
            >
              <div onMouseLeave={this.handleToggle(false)}>
                <Container
                  padding={`${SIZE_28} 0 0`}
                >
                  <Container
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    shadow
                    borderColor="gray_0"
                    borderStyle="solid"
                    backgroundColor="white"
                    maxWidth={SIZE_WIDE}
                    width={SIZE_360}
                    padding={`${SIZE_24} 0`}
                  >
                    <Icon type="problem" color="red" size={48} />
                    <Container
                      padding={`${SIZE_20} ${SIZE_4} ${SIZE_4}`}
                    >
                      <Text fontSize={16} fontWeight="bold">Будьте внимательны</Text>
                    </Container>
                    <Text fontSize={14}>
                      В ЖК есть проблемные корпуса.
                    </Text>
                    <Container
                      padding={`${SIZE_20} 0 0`}
                    >
                      <Link onClick={this.onMoreButtonClick} url={url} target="blank">
                        <Button type="secondary">Узнать подробнее</Button>
                      </Link>
                    </Container>
                  </Container>
                </Container>
              </div>
            </ClickOutside>
          }
        >
          <Container
            onMouseEnter={this.onIconHover}
          >
            <TextAndIcon
              iconType="problem"
              reverse color={isOpen ? 'red_1' : 'red'}
              iconColor={isOpen ? 'red_1' : 'red'}
              fontWeight="bold"
              alignItems="baseline"
              offset={4}
              fontSize={12}
              iconSize={12}
            >
              Будьте внимательны
            </TextAndIcon>
          </Container>
        </MountPopup>
      </span>
    );
  }

  private handleToggle = (value?: boolean) => () => {
    const { isOpen } = this.state;

    this.setState({ isOpen: value || !isOpen });
  }
}
